export default {"src":"/_next/static/media/0x8e870d67f660d95d5be530380d0ec0bd388289e1.441a3a1d.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};